<template>
  <div class="content-wrapper">
    <SendGiftMenu
      header="Shopping Bag"
      back-to="GiftList"
      :display-stepper="!!shoppingBagProducts.length"
    />

    <template>
      <ShoppingBagList />
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { layouts, scrollPageToTop, storeModules } from '../../helpers'
import SendGiftMenu from '@/components/SendGiftMenu'
import ShoppingBagList from '@/components/SendGiftFlow/ShoppingBagList'
import store from '../../store'

export default {
  name: 'ShoppingBag',
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (
      store.state.team.team.teamModuleNames.includes(storeModules.swag_store)
    ) {
      next()
    } else if (
      store.state.team.team.teamModuleNames.includes(storeModules.project)
    ) {
      next({ name: 'Projects' })
    }
  },
  components: {
    SendGiftMenu,
    ShoppingBagList
  },
  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.PAIGE_DASHBOARD)
    scrollPageToTop()
  },
  computed: {
    ...mapState({
      shoppingBagProducts: state => state.order.shoppingBagProducts
    })
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

@media screen and (max-width: 1100px) and (min-width: 350px) {
  .content-wrapper {
    padding-right: 0;
  }
}

@media screen and (max-width: 620px) and (min-width: 500px) {
}

@media screen and (max-width: 499px) and (min-width: 350px) {
}
</style>
